export var EConstructionStatus;
(function (EConstructionStatus) {
  EConstructionStatus["Finished"] = "finished";
  EConstructionStatus["InProgress"] = "inProgress";
  EConstructionStatus["InProject"] = "inProject";
  EConstructionStatus["InnerFinishing"] = "innerFinishing";
  EConstructionStatus["LowerFloors"] = "lowerFloors";
  EConstructionStatus["SitePreparation"] = "sitePreparation";
  EConstructionStatus["Trench"] = "trench";
  EConstructionStatus["Undefined"] = "undefined";
  EConstructionStatus["UnderConstruction"] = "underConstruction";
  EConstructionStatus["UpperFloors"] = "upperFloors";
})(EConstructionStatus || (EConstructionStatus = {}));